import { inject, Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import {
  getShareableLinkFromCurrentUrl,
  snapshot,
} from '@principle-theorem/shared';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class CopyShareableLinkTool implements IManagementTool {
  private _clipboard = inject(Clipboard);
  private _snackBar = inject(MatSnackBar);
  private _organisation = inject(OrganisationService);

  readonly name = 'copy-shareable-link';
  readonly label = 'Copy Shareable Link';
  readonly icon = 'link';
  readonly description =
    'Copy a shareable link with the current organisation scope';

  async run(_context: IToolRunContext): Promise<void> {
    const organisation = await snapshot(this._organisation.organisation$);
    if (!organisation) {
      this._snackBar.open('No organisation selected', 'OK', {
        duration: 3000,
      });
      return;
    }

    const link = getShareableLinkFromCurrentUrl(organisation.ref.id);
    const copied = this._clipboard.copy(link);

    if (copied) {
      this._snackBar.open('Shareable link copied to clipboard', 'OK', {
        duration: 3000,
      });
    } else {
      this._snackBar.open('Failed to copy link to clipboard', 'OK', {
        duration: 3000,
      });
    }
  }
}
